import React, { useEffect, useState } from 'react';
import { getForms } from '../../../actions/formActions';
import { listCronJobs } from '../../../actions/adminActions';
import { useSelector, useDispatch } from 'react-redux';
import Listing from '../../../components/Common/Listing/Listing';
import _ from 'lodash'

const CronJobs = () => {
    const listFormKey = "admin_cronjob_list_form";
    const dispatch = useDispatch();
    const adminState = useSelector((state) => state.admin);
    const formState = useSelector((state) => state.forms);
    const { formJson = {} } = formState;
    const listForm = formJson[listFormKey];
    const { cronJobListing = {} } = adminState;
    const [fetchingList, setFetchingList] = useState(true);
    const { headers = [], data: listData = [], meta = {} } = cronJobListing;

    useEffect(() => {
        setFetchingList(true);
        dispatch(getForms(listFormKey));
    }, [])

    useEffect(() => {
        if (!_.isEmpty(cronJobListing) && fetchingList) {
            setFetchingList(false);
        }
    }, [cronJobListing])

    useEffect(() => {
        if (!_.isEmpty(listForm)) {
            dispatch(listCronJobs({}, listFormKey));
        }
    }, [listForm]);

    const handleSearch = () => {
        dispatch(listCronJobs({}, listFormKey));
    }

    return (
        <div style={{ position: 'relative', paddingBottom: '0px' }}> {/* Added padding-bottom */}
            <Listing
                headers={headers}
                data={listData}
                onSearch={handleSearch}
                meta={meta}
                fetchingList={fetchingList}
            />
        </div>
    );
};

export default CronJobs;